/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'
import UiPill from 'components/Ui/UiPill'

interface UiPackagePillProps {
    value: string
    children?: React.ReactNode
    className?: string
}

const UiPackagePill: React.FC<UiPackagePillProps> = ({
    value,
    children,
    className,
}) => {
    return (
        <UiPill
            className={clsx(
                'UiPackagePill bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-100',
                className
            )}
        >
            {children || value}
        </UiPill>
    )
}

export default UiPackagePill
